export default class PosterImageModel {
    constructor(public type: "original" | "default", public altText: string, public url: string) {}
}
